import type { Location } from "react-router"

export function getImageSearchEntryId(location: Pick<Location, "state" | "key">): string {
  const id: unknown = location.state?.imageSearchEntryId
  return typeof id === "string" && id.length > 0 ? id : location.key
}

export function getScrollRestorationKey(location: Location): string {
  return location.pathname === "/image-search"
    ? getImageSearchEntryId(location)
    : `${location.pathname}${location.search}`
}
